module.exports = __webpack_public_path__ + "static/img/lb1.c60ca0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb1.jpg
// module id = zgQw
// module chunks = 0